export default __webpack_public_path__ + "media/components/Header/Images/Text_big-738982671f9ca8a7b6f3163efef5d0c9.svg";